<div class="list-popup">
    <app-cx-builder [selectionType]="'copy'" [copyType]="copyType"></app-cx-builder>
</div>
